// The authentication verdict reads `@heidi/auth/state`. The rest of this seam
// stays package-scoped; `requireIntegrationsDataPort` still names a missing key.

import { useIsAuthenticated as useAuthIdentity } from '@heidi/auth/state';

/** The provider-aware authentication verdict, from the auth identity hook. */
export const useIsAuthenticated = (): boolean => useAuthIdentity().isAuthenticated;
